import React from 'react'
import './Client.css'
import CountUp from 'react-countup';


const Client = () => {
  return (
    <>
    <div className='jumb'>
        <div className='jumbotron'>
            <div className='row'>
        <div className="col-lg-4 happyClient text-light text-center mt-5 p-3">
                {/* <span className='d-none'>{curElement.id}</span> */}
               
                   {/* <FaUser className = 'client'/> */}
               
             
                <h1 className='mt-5'>Happy Clients</h1>
              
                <h2> <CountUp end={30} duration={7} enableScrollSpy = {true}/><span> +</span></h2>
              
              </div>
              <div className='col-lg-2'></div>

              <div className="col-lg-4 happyClient text-light text-center mt-5 py-3">
                {/* <span className='d-none'>{curElement.id}</span> */}
               
                   {/* <FaUser className = 'client'/> */}
               
             
                <h1 className='mt-5'>Project Completed</h1>
              
                <h2> <CountUp end={20} duration={7} enableScrollSpy = {true}/><span> +</span></h2>
              
              </div>
              </div>
        </div>
    </div>
    </>
  )
}

export default Client